import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    placeholder: { default: () => ['开始时间', '结束时间'] },
    target: { default: null },
    source: { default: null }
  },
  emits: ["onChange"],
  setup(__props: any, { emit: __emit }) {

const emit = __emit

const props = __props;

const value = ref([props.startTime, props.endTime]);

const handleSelect = (e, stringTime) => {
  if (props.target && props.source) {
    props.target.forEach((key, index) => {
      props.source[key] = stringTime[index] ? stringTime[index] : null;
    });
  }
  emit('onChange', stringTime);
};


return (_ctx: any,_cache: any) => {
  const _component_a_range_picker = _resolveComponent("a-range-picker")!

  return (_openBlock(), _createBlock(_component_a_range_picker, {
    value: value.value,
    "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((value).value = $event)),
    placeholder: _ctx.placeholder,
    onChange: handleSelect,
    allowClear: ""
  }, null, 8, ["value", "placeholder"]))
}
}

})